import { render, staticRenderFns } from "./createsupplier.vue?vue&type=template&id=2823ce3a&"
import script from "./createsupplier.vue?vue&type=script&lang=ts&"
export * from "./createsupplier.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "createsupplier.vue"
export default component.exports